import PropTypes from 'prop-types';
import React from 'react';

import {useRemoteConfigContext} from '../../contexts/RemoteConfigContext';

const getNestedValue = (obj, path) => {
  return path.split('.').reduce((current, key) => current?.[key], obj);
};

export const DynamicContent = ({
  configPath,
  fallbackContent,
  className,
  renderAsHtml = false,
  as = 'div'
}) => {
  const {config, loading, error} = useRemoteConfigContext();

  if (loading) {
    return fallbackContent || null;
  }

  if (error || !config) {
    return fallbackContent || null;
  }

  const content = getNestedValue(config, configPath);

  if (!content) {
    return fallbackContent || null;
  }

  if (renderAsHtml) {
    return (
      <div className={className} dangerouslySetInnerHTML={{__html: content}} />
    );
  }

  const Component = as;
  return <Component className={className}>{content}</Component>;
};

DynamicContent.propTypes = {
  configPath: PropTypes.string.isRequired,
  fallbackContent: PropTypes.node,
  className: PropTypes.string,
  renderAsHtml: PropTypes.bool,
  as: PropTypes.string
};
